import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { CustomLink } from '@/components/CustomLink/CustomLink';

const checked = css`
  background-image: url('/images/check-white.svg');
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid ${({ theme }) => theme.palette.brand.main};
  background-color: ${({ theme }) => theme.palette.brand.main};
`;

export const Card = styled(CustomLink)`
  display: flex;
  flex-direction: column;
  min-width: 130px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const CardPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 130px;
  gap: 5px;
  user-select: none;
`;

export const ImageWrapper = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  width: 100%;
  min-height: 130px;
  border-radius: 14px;
  max-height: 204px;
  aspect-ratio: 230 / 170;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.05);
  }
`;

export const BookmarkButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  border: none;
  padding: 5px;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  background: transparent;
`;

export const Title = styled(Typography.Body).attrs(() => ({
  $variant: '2',
}))<{ $hasPadding?: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.2;
  margin-bottom: auto;
  ${({ $hasPadding }) => $hasPadding && 'margin-top: 5px;'}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const Price = styled(Typography.Numbers).attrs(() => ({
  $variant: '2',
}))`
  font-size: 18px;
  margin: 5px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const Footer = styled.div`
  display: flex;
  margin-top: 5px;
  align-items: center;
  justify-content: space-between;
`;

export const DateAndRegion = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
  $isEllipsis: true,
}))`
  font-size: 13px;
`;

export const Checkbox = styled.div<{ $isChecked: boolean }>`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.15);
  box-shadow: 2px 5px 12px 0px rgba(0, 0, 0, 0.15);
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};

  ${({ $isChecked }) => $isChecked && checked}
`;

export const KindsList = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
`;

export const Label = styled(Typography.Caption)`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 10px;
  width: 69px;
  left: 10px;
  z-index: 1;
  font-weight: 500;
  height: 21px;
  border-radius: 4px;
  padding: 0 5px;
  color: ${({ theme }) => theme.palette.system.white};
  background-color: ${({ theme }) => theme.palette.system.deepBlue};
`;

export const StatusLabel = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  font-weight: 500;
  text-align: center;
  padding: 0 5px;
  font-size: 15px;
  background-color: rgba(0, 0, 0, 0.6);

  p {
    color: ${({ theme }) => theme.palette.system.white};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 12px;
  }
`;
